<template>
    <NuxtLayout>
        <div class="body-block">
            <div class="title-container">
                <div class="container-xl">
                    <div class="doc-title-container">
                        <div class="row">
                            <div class="col-sm-12 col-lg-6">
                                <h1 class="page_title mt-10">Согласие на обработку персональных данных Пользователя</h1>
                            </div>
                            <div class="col-lg-6 d-none d-lg-block text-end">
                                <img src="/images/documents/document_view.png" alt="" class="doc-image"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="body-documents">
                <div class="container-xl">
                    <p><span style="font-size: 1rem;">Настоящим я, Пользователь, в соответствии с Законом Республики Казахстан от 21 мая 2013 года № 94-V«О персональных данных и их защите», свободно, своей волей и в своем интересе выражаю свое согласие ТОО «ПЭК Казахстан», БИН 121140009856, юр. адрес: 050050, Казахстан, г. Алматы, Жетысуский район, ул. Казыбаева, д. 3 (далее «Оператор»), на обработку, при использовании мной&nbsp; интернет-сайта, расположенного по адресу https://pecom.kz/ (далее - «Сайт»), следующих моих персональных данных:</span>
                    </p>
                    <ul>
                        <li>фамилия, имя, отчество;</li>
                        <li>вид, серия, номер документа, удостоверяющего личность, наименование органа, выдавшего его,
                            дата выдачи;
                        </li>
                        <li>адрес места жительства (адрес регистрации, фактического проживания);&nbsp;</li>
                        <li>номер контактного телефона, адрес электронной почты или сведения о других способах связи;
                        </li>
                        <li>аккаунты в социальных сетях и мессенджерах;</li>
                        <li>пол;</li>
                        <li>дата рождения;</li>
                        <li>информация о гражданстве;</li>
                        <li>реквизиты банковского счета;</li>
                        <li>данные о банковской карте;</li>
                        <li>логин, пароль (в случае авторизации на Сайте);</li>
                        <li>файлы Cookie (информация о действиях, совершаемых в «Веб-сервисах», включая, но не
                            ограничиваясь: данные о используемых устройствах, об источнике захода в «Веб-сервисы»,
                            поискового запроса, пользовательских кликов, просмотров страниц «Веб-сервисы», заполнения
                            окон, просмотры баннеров и видео, параметры сессии, данные о времени посещения, данные о
                            местоположении и т.д.)
                        </li>
                    </ul>
                    <p>Обработка вышеуказанных персональных данных может осуществляться неавтоматизированным,
                        автоматизированным, а также смешанным способом посредством их сбора, записи, систематизации,
                        накопления, хранения, уточнения (обновления, изменения), извлечения, использования, передачи
                        третьим лицам, обезличивания, блокирования, удаления, уничтожения в следующих целях:</p>
                    <p>использования Пользователем Сайта для получения доступа к информации, сервисам и услугам, данные
                        о которых размещены на Сайте;</p>
                    <ul>
                        <li>осуществления Пользователем регистрации, создания учетной записи, использование функционала
                            Личного кабинета Сайта;&nbsp;
                        </li>
                        <li>обработка обращений Пользователя и предоставление обратной связи;</li>
                        <li>проведение статистических, аналитических и маркетинговых исследований по использованию
                            пользователями ресурсов Сайта, в том числе, но не ограничиваясь для обеспечения
                            бесперебойной и качественной работы Сайта;
                        </li>
                        <li>предоставление Пользователю рекламной и маркетинговой информации о специальных предложениях,
                            включая проведение специальных мероприятий, акций, презентаций в отношении услуг ТОО «ПЭК
                            Казахстан»;
                        </li>
                        <li>организация программ лояльности, иных акций в рамках оказываемых услуг;</li>
                        <li>предоставления информации об услугах ТОО «ПЭК Казахстан»;</li>
                        <li>формирование и ведение реестра потенциальных потребителей услуг ТОО «ПЭК Казахстан».</li>
                    </ul>
                    <p>Я выражаю согласие на трансграничную передачу моих персональных данных ООО «ПЭК» ИНН/КПП
                        7721823853/772101001, зарегистрированному по адресу: 109428, Россия, г. Москва, 1-й Вязовский
                        пр-д, д. 4 стр. 19.</p>
                    <p>Я подтверждаю, что с ознакомлен с положениями Законом Республики Казахстан от 21 мая 2013 года №
                        94-V «О персональных данных и их защите», политикой в отношении обработки персональных данных и
                        Политикой обработки файлов cookie, размещенной на Сайте.</p>
                    <p>Датой выдачи настоящего согласия на обработку персональных данных является</p>
                    <p>дата регистрации на Сайте. Согласие действует с момента его предоставления в течение всего
                        периода использования Пользователем Сайта, до момента отзыва настоящего согласия или до
                        достижения вышеуказанных целей обработки персональных данных.</p>
                    <p>Настоящее согласие может быть отозвано посредством направления Пользователем заявления с
                        требованием о прекращении обработки персональных данных на вышеуказанный адрес Оператора или
                        путем направления скан-копии заявления на адрес электронной почты pnd@pecom.ru. Заявление должно
                        содержать номер основного документа, удостоверяющего личность Пользователя, сведения о дате
                        выдачи указанного документа, а также собственноручную подпись Пользователя.</p>
                    <div><br></div>
                </div>
            </div>
        </div>
    </NuxtLayout>
</template>

<script>
export default {
    name: "index"
}
</script>

<style scoped>

</style>
